import { ProgressIndicator } from '@fluentui/react';
import React from 'react';
import { InView } from 'react-intersection-observer';

interface PaginationProps {
  showProgressIndicator: boolean;
  onLoadMore?: () => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  showProgressIndicator,
  onLoadMore,
}) => {
  if (showProgressIndicator)
    return (
      <InView onChange={(inView) => inView && onLoadMore?.()}>
        <div style={{ height: 40 }}>
          <ProgressIndicator barHeight={4} />
        </div>
      </InView>
    );
  else return null;
};
